<template>
	<DjCardBlog
		:category="categoryText"
		:public-id="publicId"
		:title="titleText"
		:cta="$t('blogPage.readMore')"
		:post-href="blogPath"
		:new-tab="newTab"
		@on-category-click="$emit('setCategory')"
	/>
</template>

<script lang="ts">
import { computed, defineComponent } from "vue";

export default defineComponent({
	name: "CardBlog",
	props: {
		newTab: {
			type: Boolean,
			default: false,
		},
		post: {
			type: Object,
			default: () => {
				return {};
			},
		},
	},
	emits: ["setCategory"],
	setup(props) {
		const { locale } = useI18n();

		function localized(value: unknown) {
			const localeMap = value as Record<string, string> | undefined;
			return (
				localeMap?.[locale.value] ||
				localeMap?.hu ||
				localeMap?.en ||
				localeMap?.ro ||
				Object.values(localeMap || {}).find((v) => Boolean(v)) ||
				""
			);
		}

		const blogPath = computed(() => {
			const slug = (props.post as { slug?: string })?.slug;
			return slug ? `/${locale.value}/blog/post/${slug}` : "";
		});

		const titleText = computed(() => localized((props.post as { name?: unknown })?.name));
		const categoryText = computed(() =>
			localized((props.post as { category?: { name?: unknown } })?.category?.name)
		);
		const publicId = computed(() => (props.post as { image?: { cloudinary?: string } })?.image?.cloudinary || "");

		return {
			locale,
			blogPath,
			titleText,
			categoryText,
			publicId,
		};
	},
});
</script>
